(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["topdc-product-black-friday"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('topdc-product-black-friday')){
 class TopdcProductBlackFriday extends HTMLElement{
  connectedCallback(){
   if(this.abortController)return;
   this.abortController=new AbortController();
   this.copyButton=this.querySelector('[data-bf-copy]');
   if(this.copyButton)this.copyButton.addEventListener('click',()=>this.copyCode(),{signal:this.abortController.signal});
  }
  disconnectedCallback(){this.abortController?.abort();this.abortController=null;clearTimeout(this.resetTimer);}
  fallbackCopy(code){
   const active=document.activeElement;
   const input=document.createElement('textarea');
   input.value=code;input.readOnly=true;input.style.cssText='position:fixed;left:0;top:0;opacity:0;pointer-events:none;';
   this.append(input);input.select();input.setSelectionRange(0,code.length);
   let copied=false;try{copied=document.execCommand('copy');}catch{}
   input.remove();if(active&&active.isConnected)active.focus({preventScroll:true});
   return copied;
  }
  async copyCode(){
   if(this.copying||!this.copyButton)return;
   const button=this.copyButton,code=button.dataset.code,label=this.querySelector('[data-bf-copy-label]'),status=this.querySelector('[data-bf-status]');
   if(!code)return;
   clearTimeout(this.resetTimer);this.copying=true;button.disabled=true;button.setAttribute('aria-busy','true');
   let copied=false;
   try{if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(code);copied=true;}}catch{}
   if(!copied)copied=this.fallbackCopy(code);
   if(copied){
    label.textContent=button.dataset.copiedText;status.textContent=button.dataset.success;
    this.resetTimer=setTimeout(()=>{if(this.isConnected){label.textContent=button.dataset.copyText;status.textContent='';}},2500);
   }else{
    label.textContent=button.dataset.copyText;status.textContent=button.dataset.failed;
    const range=document.createRange();range.selectNodeContents(this.querySelector('[data-bf-code]'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);
   }
   button.disabled=false;button.removeAttribute('aria-busy');this.copying=false;
  }
 }
 customElements.define('topdc-product-black-friday',TopdcProductBlackFriday);
}
  } catch(e) { console.error(e); }
})();

})();
